import {
  formatNetWeight,
  formatUnitPrice,
  formatUnitPriceCA,
  poundsPerKG,
} from "@Components/cart/helpers/helpers";

export const transformUnitOfMeasure = (weight: number, UOM: string) => {
  return UOM === "KG"
    ? (weight * poundsPerKG).toFixed(1)
    : (weight / poundsPerKG).toFixed(1);
};

export const GetWeightText = (
  weight: number,
  UOM: string,
  currentLocale: string
) => {
  return formatNetWeight(weight, UOM, currentLocale);
};

export const GetPerWeightPrice = (price: number, UOM: string) => {
  const priceData = [
    {
      value: {
        centAmount: price * 100,
      },
    },
  ];

  return formatUnitPrice(priceData, UOM);
};

export const GetPerWeightPriceCA = (
  priceText: number,
  weight: number,
  UOM: string,
  currentLocale: string
) => {
  const priceData = [
    {
      value: {
        centAmount: priceText * 100,
      },
    },
  ];
  const weightStr = weight?.toString();
  return formatUnitPriceCA(priceData, weightStr, UOM, currentLocale);
};
